// @ts-nocheck
/**
 * ツインキーシステム - メインアプリケーション
 * @module twinKey/ui/TwinKeyApp
 */

import React from 'react';
import { TwinKeyProvider, useTwinKeyContext, SCREENS } from '../context/TwinKeyContext';
import {
  TwinKeyHub,
  KeySelectionScreen,
  PartyScreen,
  DungeonScreen,
  BattleScreen,
  ResultScreen,
  AlchemyScreen,
} from './screens';
import styles from './styles/twinKeyStyles';

/**
 * ツインキーメインアプリケーション
 * @param {Object} props - プロパティ
 * @param {Object} props.playerData - プレイヤーデータ
 * @param {Function} props.updatePlayerData - プレイヤーデータ更新関数
 * @param {Array} props.allCards - 全カードデータ
 * @param {Function} props.onBack - 戻るコールバック
 * @param {Function} props.onDungeonComplete - ダンジョン完了時のコールバック（日付進行処理）
 */
export function TwinKeyApp({ playerData, updatePlayerData, allCards, onBack, onDungeonComplete }) {
  return (
    <TwinKeyProvider
      playerData={playerData}
      updatePlayerData={updatePlayerData}
      allCards={allCards}
      onBack={onBack}
      onDungeonComplete={onDungeonComplete}
    >
      <TwinKeyRouter />
    </TwinKeyProvider>
  );
}

/**
 * 画面ルーター
 */
function TwinKeyRouter() {
  const { state } = useTwinKeyContext();
  const currentScreen = state.screen; // screen を使用（currentScreen ではない）

  // 画面に応じたコンポーネントを表示
  const renderScreen = () => {
    switch (currentScreen) {
      case SCREENS.HUB:
        return <TwinKeyHub />;
      case SCREENS.KEY_SELECTION:
        return <KeySelectionScreen />;
      case SCREENS.PARTY:
        return <PartyScreen />;
      case SCREENS.DUNGEON:
        return <DungeonScreen />;
      case SCREENS.BATTLE:
        return <BattleScreen />;
      case SCREENS.RESULT:
        return <ResultScreen />;
      case SCREENS.ALCHEMY:
        return <AlchemyScreen />;
      default:
        return <TwinKeyHub />;
    }
  };

  return (
    <div style={styles.appContainer}>
      {renderScreen()}
    </div>
  );
}

export default TwinKeyApp;
